import React from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useCookieConsent } from "@/context/CookieConsent";

const TEXT = {
  fr: {
    body:
      "Ce site utilise uniquement des cookies essentiels à son fonctionnement (aucun cookie de suivi ni publicitaire). La page Contact intègre une carte OpenStreetMap (service tiers) qui n'est chargée qu'avec votre consentement.",
    accept: "Tout accepter",
    reject: "Refuser",
    policy: "Politique de cookies",
  },
  en: {
    body:
      "This site uses only cookies essential to its operation (no tracking or advertising cookies). The Contact page embeds an OpenStreetMap map (third-party service) that loads only with your consent.",
    accept: "Accept all",
    reject: "Reject",
    policy: "Cookie policy",
  },
};

export default function CookieBanner() {
  const { lang } = useApp();
  const { consent, accept, reject } = useCookieConsent();
  const c = TEXT[lang] || TEXT.fr;

  // Only show while undecided (null). Hide during loading (undefined) or after choice.
  if (consent !== null) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[100] px-4 pb-4 sm:px-6"
      role="dialog"
      aria-live="polite"
      aria-label={c.policy}
      data-testid="cookie-banner"
    >
      <div className="mx-auto max-w-[1100px] rounded-2xl border border-white/10 bg-[#0A0A0A]/95 p-5 text-white shadow-2xl backdrop-blur-md md:p-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#8CC63F]/15 text-[#8CC63F]">
              <Cookie className="h-4 w-4" />
            </span>
            <p className="font-poppins text-sm leading-relaxed text-white/80">
              {c.body}{" "}
              <Link to="/politique-cookies" className="font-semibold text-[#1CADE4] underline underline-offset-2 hover:text-white" data-testid="cookie-banner-policy-link">
                {c.policy}
              </Link>
            </p>
          </div>
          <div className="flex shrink-0 gap-3">
            <button
              onClick={reject}
              data-testid="cookie-reject"
              className="rounded-full border border-white/25 px-5 py-2.5 font-poppins text-sm font-semibold text-white/90 transition-colors hover:bg-white/10"
            >
              {c.reject}
            </button>
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="rounded-full bg-[#8CC63F] px-5 py-2.5 font-poppins text-sm font-semibold text-[#0A0A0A] transition-transform hover:scale-105"
            >
              {c.accept}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
